module.exports = __webpack_public_path__ + "static/img/top-25-logo.d562f87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/top-25-logo.png
// module id = o1Qx
// module chunks = 0